var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "238b333a-178b-4cd4-ac1d-e298890126cc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 871.91,
    height: 538.91,
    viewBox: "0 0 871.91 538.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "73e15490-e73a-4daf-a8fa-871575ee9321",
    x1: 435.95,
    y1: 538.91,
    x2: 435.95,
    y2: 377.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df8be15c-9459-42d7-bdb7-69a0793b072a",
    x1: 895.46,
    y1: 705.26,
    x2: 895.46,
    y2: 584.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b3b3b3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec5b6c4a-1901-436f-adb1-6a75e1cf02b2",
    x1: 858.28,
    y1: 627.87,
    x2: 858.28,
    y2: 622.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad8637ff-19a2-4376-ab14-889c914baa6d",
    x1: 884.88,
    y1: 621.23,
    x2: 884.88,
    y2: 603.52,
    xlinkHref: "#ec5b6c4a-1901-436f-adb1-6a75e1cf02b2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4f6e45b9-bafa-41f4-95be-649755ef2db0",
    x1: 547.45,
    y1: 337.11,
    x2: 547.45,
    y2: 180.55,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a7aca18-822d-4cd6-8022-bc12f6b28c27",
    transform: "translate(-164.05 -180.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "19379121-7478-408f-b0f7-0bc5cc67c984",
    "data-name": "<Clipping Path>",
    d: "M611.43,246.64H549v25.9h35.95c-3.35,16.45-17.37,25.9-35.95,25.9a39.6,39.6,0,1,1,0-79.21,38.75,38.75,0,0,1,24.68,8.83l19.5-19.5A67,67,0,1,0,549,325.85c33.51,0,64-24.37,64-67A55.6,55.6,0,0,0,611.43,246.64Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6627af2f-6387-4a0d-b0b9-ac53cdbc3a5b",
    x1: 378.88,
    y1: 511.52,
    x2: 378.88,
    y2: 366.33,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ddaf1a7f-9880-4904-953e-5b43016bf555",
    x1: 378.07,
    y1: 483.02,
    x2: 378.07,
    y2: 406.49,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff2f0951-b323-4635-82fe-8231a68c23a1",
    x1: 481.22,
    y1: 511.34,
    x2: 481.22,
    y2: 371.35,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feead546-cd88-4849-9d6b-2d10146d77ca",
    x1: 443.8,
    y1: 328.74,
    x2: 443.8,
    y2: 216.51,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "11171aa7-1c4b-491e-968e-ec86b16c2491",
    x1: 708.4,
    y1: 487.94,
    x2: 708.4,
    y2: 415.88,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e26bf7bd-782d-4f56-b0ff-5a31b16d8be8",
    x1: 744.45,
    y1: 486.82,
    x2: 744.45,
    y2: 417.99,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "585d3746-95bf-4104-b482-1a8856ed9312",
    x1: 780.78,
    y1: 486.82,
    x2: 780.78,
    y2: 437.78,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a907c335-795f-486f-b1b8-609a83bdae17",
    x1: 832.79,
    y1: 509.37,
    x2: 832.79,
    y2: 437.64,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "13dbe9af-638b-435e-9f44-8918d669c0cb",
    x1: 858.05,
    y1: 379.79,
    x2: 858.05,
    y2: 324.38,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6e785759-1792-4e56-ab13-97f1c71d675c",
    x1: 898.6,
    y1: 381.19,
    x2: 898.6,
    y2: 297.72,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1b9d0fbd-4a18-480c-8952-bc1dca6d3c24",
    x1: 939.58,
    y1: 380.99,
    x2: 939.58,
    y2: 323.88,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "08a32409-e9e2-41c9-b320-daf7c916d8a5",
    x1: 816.78,
    y1: 381.19,
    x2: 816.78,
    y2: 323.68,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2338fc2-5e48-4cc0-83aa-3fe60e8d838c",
    x1: 976.13,
    y1: 379.79,
    x2: 976.13,
    y2: 324.99,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "250804e8-9fcb-4348-8b6b-ec6692d86991",
    x1: 784.46,
    y1: 379.79,
    x2: 784.46,
    y2: 289.72,
    xlinkHref: "#73e15490-e73a-4daf-a8fa-871575ee9321"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search engines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 377.68,
    width: 871.91,
    height: 161.23,
    fill: "url(#73e15490-e73a-4daf-a8fa-871575ee9321)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.09,
    y: 382.96,
    width: 860.45,
    height: 147.38,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.94,
    y: 413.04,
    width: 500.19,
    height: 87.71,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.21,599.19a46.32,46.32,0,1,0-7.58,70.55l33.48,34.83a2.25,2.25,0,0,0,3.19.06l8.34-8a2.25,2.25,0,0,0,.06-3.19l-33.48-34.83A46.32,46.32,0,0,0,916.21,599.19Zm-10.43,56a33.13,33.13,0,1,1,.92-46.85A33.13,33.13,0,0,1,905.78,655.17Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#df8be15c-9459-42d7-bdb7-69a0793b072a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M858.28,622.08c-3.73,0-3.73,5.79,0,5.79S862,622.08,858.28,622.08Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#ec5b6c4a-1901-436f-adb1-6a75e1cf02b2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M884.25,603.53a27.83,27.83,0,0,0-24,12.4c-1.58,2.48,2.91,4.67,4.49,2.2,4-6.29,11.65-10.28,19.9-10.07a25.36,25.36,0,0,1,20.69,12c1.58,2.61,5.73.24,4.15-2.35C904.43,609.41,894.61,603.77,884.25,603.53Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#ad8637ff-19a2-4376-ab14-889c914baa6d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M916.21,594.1a46.32,46.32,0,1,0-7.58,70.55l33.48,34.83a2.25,2.25,0,0,0,3.19.06l8.34-8a2.25,2.25,0,0,0,.06-3.19L920.23,653.5A46.32,46.32,0,0,0,916.21,594.1Zm-10.43,56a33.13,33.13,0,1,1,.92-46.85A33.13,33.13,0,0,1,905.78,650.08Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M858.28,617c-3.73,0-3.73,5.79,0,5.79S862,617,858.28,617Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M884.25,598.44a27.83,27.83,0,0,0-24,12.4c-1.58,2.48,2.91,4.67,4.49,2.2,4-6.29,11.65-10.28,19.9-10.07a25.36,25.36,0,0,1,20.69,12c1.58,2.61,5.73.24,4.15-2.35C904.43,604.32,894.61,598.67,884.25,598.44Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#6c63ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b66f4108-1dd3-4103-b715-537ec4a4772e",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.18,244.59H549.23v30.24h42c-3.91,19.21-20.28,30.24-42,30.24a46.26,46.26,0,0,1,0-92.51,45.25,45.25,0,0,1,28.82,10.32l22.77-22.77a78.23,78.23,0,1,0-51.59,137c39.14,0,74.72-28.47,74.72-78.28A64.94,64.94,0,0,0,622.18,244.59Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#4f6e45b9-bafa-41f4-95be-649755ef2db0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a7aca18-822d-4cd6-8022-bc12f6b28c27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.81,298.43V219.22l51.79,39.6Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.81,219.22l51.79,39.6,21.33-18.58L619,228.36V185.71H472.81Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.81,298.43l91.4-70.07,24.07,3L619,185.71V331.94H472.81Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,331.94l-94.44-73.12-12.19-9.14L619,219.22Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#4285f4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d8826248-d006-481d-80db-43bc27daf51c",
    "data-name": "g3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "90809b75-c047-41d3-8e27-ed57a95840b3",
    "data-name": "g3956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4e8d5321-71ab-4cf6-9531-1699e46183bc",
    "data-name": "path61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.87,366.33c42.47,0,74.92,31.43,74.92,72.58s-32.45,72.6-74.92,72.6S304,480.07,304,438.91,336.4,366.33,378.87,366.33ZM453.8,511.52Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#6627af2f-6387-4a0d-b0b9-ac53cdbc3a5b)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cd9086b0-0465-4ddd-b26e-08d7ca60be30",
    "data-name": "g63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26e2b761-0ff4-4c57-a74a-b23f719f2f6e",
    "data-name": "id4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa638075-2341-4c20-8c97-6443789b9aee",
    "data-name": "path66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.65,414c.17-2.52.36-5,.71-7.53h-57V414c5.73.36,11.29.9,17,1.25,10.75,13.08,21.5,26.17,32.43,39.42V475c-6.09.54-12.19.9-18.28,1.44V483h56.28V476.4c-6.09-.37-12.19-.54-18.28-.72.18-7.16.36-14.51.54-21.68,10.57-9.32,21-18.64,31.37-28,5.37-.36,10.75-.71,16.3-1.25V416c-15.95.18-31.72.36-47.67.71v7.36c5.91.36,11.83.53,17.74.71-7.7,6.63-15.42,13.08-23.12,19.72-7.89-9.68-15.77-19.53-23.66-29.22C365.25,414.73,370.44,414.38,375.65,414Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#ddaf1a7f-9880-4904-953e-5b43016bf555)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "c909fb51-d884-4b77-9a53-133209191f18",
    "data-name": "g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fad3897a-b382-46ab-97cd-992d89cd1312",
    "data-name": "id5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b723b098-9615-45ec-9744-2c024445d2d9",
    "data-name": "path71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506,373.52l-43.2-2.16c-.72,34.24-1.44,68.65-2.15,102.89,6.81.71,13.8,1.43,20.6,2.15Q493.58,424.78,506,373.52ZM458.63,511.34h24.73v-20.6l-26.88-2.15C457.19,496.29,457.92,503.82,458.63,511.34Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#ff2f0951-b323-4635-82fe-8231a68c23a1)"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c54374c9-5ce3-408c-944d-67488ba47ad9",
    "data-name": "g3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0625f036-f82d-4f60-b46b-c9ebda46575e",
    "data-name": "g3956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "0af1f165-b901-461e-ab4c-b27d5265da26",
    "data-name": "path61",
    d: "M381.57,373.83c38.09,0,67.18,28.18,67.18,65.09S419.65,504,381.57,504s-67.18-28.19-67.18-65.1S343.48,373.83,381.57,373.83ZM448.76,504Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#6b0094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c03fa78e-fbaa-491c-9ca6-f015ede67acc",
    "data-name": "g63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "88a9ccd2-aa29-411b-a295-ecc501fde54c",
    "data-name": "id4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f24379df-238d-4d18-84fa-01d663e5d57c",
    "data-name": "path66",
    d: "M378.68,416.59c.15-2.26.32-4.51.64-6.75H328.21v6.75c5.13.32,10.12.8,15.27,1.12,9.64,11.73,19.28,23.47,29.08,35.35v18.17c-5.46.48-10.93.8-16.39,1.29v5.94h50.47v-5.94c-5.46-.33-10.93-.48-16.39-.65.17-6.42.32-13,.48-19.44,9.47-8.36,18.81-16.71,28.13-25.07,4.81-.32,9.64-.64,14.62-1.12v-7.88c-14.3.17-28.45.32-42.75.64v6.6c5.3.32,10.61.47,15.91.64-6.91,5.95-13.83,11.73-20.73,17.68-7.07-8.68-14.15-17.52-21.22-26.2C369.35,417.23,374,416.91,378.68,416.59Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bed980a8-54d9-4ead-8aa7-7019110c4f84",
    "data-name": "g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4054f81e-5c95-4b6b-9e19-71fd8b4446f2",
    "data-name": "id5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "131db97b-3cb7-4435-addf-77d62cece6dc",
    "data-name": "path71",
    d: "M495.52,380.27l-38.74-1.94c-.65,30.7-1.29,61.56-1.93,92.27,6.1.64,12.37,1.28,18.48,1.93Q484.42,426.24,495.52,380.27ZM453.09,503.86h22.18V485.38l-24.1-1.93C451.8,490.36,452.45,497.11,453.09,503.86Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#6b0094"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "8dc6b1c1-e606-4fc7-a28b-e59b8b7d9e91",
    "data-name": "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3383feb4-8fcc-4817-9f82-bc69d4bd9416",
    "data-name": "path2998"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "424.45 328.74 398.91 310.84 398.91 216.51 424.61 224.38 424.61 287.81 399.65 310.05 460.56 278.01 443.68 270.37 432.25 245.59 488.7 262.89 488.7 290.48 424.45 328.74",
    fill: "url(#feead546-cd88-4849-9d6b-2d10146d77ca)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "adf0c4a8-c861-4f67-ad45-bfc4516b4b15",
    "data-name": "flowRoot3000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5241a0fb-1782-4a0b-a8f5-d9d23bc6ad1c",
    "data-name": "path3009"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.22,479.89H694v6.92h-7.67V415.88l7.67,2.29v29.16h.19q5.66-9.54,16.56-9.55,9.22,0,14.43,6.43t5.22,17.24q0,12-5.85,19.25t-16,7.23A15.76,15.76,0,0,1,694.22,479.89ZM694,460.57v6.69a14.25,14.25,0,0,0,3.86,10.08,13.77,13.77,0,0,0,20.73-1.19q4-5.33,4-14.83,0-8-3.7-12.54a12.23,12.23,0,0,0-10-4.54,13.6,13.6,0,0,0-10.76,4.66A17.09,17.09,0,0,0,694,460.57Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#11171aa7-1c4b-491e-968e-ec86b16c2491)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e9bd7740-3bac-4f11-9098-850597dc5964",
    "data-name": "path3011"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.4,428a4.86,4.86,0,0,1-3.51-1.4,4.74,4.74,0,0,1-1.45-3.56,4.91,4.91,0,0,1,5-5,5,5,0,0,1,3.58,1.43,5,5,0,0,1,0,7.09A4.91,4.91,0,0,1,744.4,428Zm3.74,58.85h-7.67V438.9h7.67Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#e26bf7bd-782d-4f56-b0ff-5a31b16d8be8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "9d1a5a1d-38c0-45ad-a4b7-043d8bfe2cf6",
    "data-name": "path3013"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.67,486.82H793V459.49q0-15.25-11.14-15.25a12.08,12.08,0,0,0-9.52,4.33,16,16,0,0,0-3.77,10.93v27.33H760.9V438.9h7.67v8h.19q5.43-9.08,15.72-9.08,7.86,0,12,5.08t4.16,14.67Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#585d3746-95bf-4104-b482-1a8856ed9312)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d360da2a-da29-47f1-af73-68a568081c1c",
    "data-name": "path3015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855,483q0,26.39-25.27,26.39A33.92,33.92,0,0,1,814.15,506l2.1-6.87c4.69,2.32,9,3.61,13.32,3.61,11.4,0,17.71-6.19,17.71-18.73v-5.24h-.19q-5.47,9.17-16.47,9.17a18,18,0,0,1-14.39-6.39c-3.63-4.26-5.61-10.05-5.61-17.23,0-8.14,2.11-14.54,6-19.34s9.38-7.34,16.18-7.34c6.46,0,11.13,2.34,14.25,7.52h.19V438.9H855Zm-7.67-17.83v-7.07a13.82,13.82,0,0,0-13.48-13.85c-11.11,0-15.08,10.11-15.16,19.65,0,9.11,4.63,17.24,14.08,17.24S847.19,473.65,847.28,465.15Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#a907c335-795f-486f-b1b8-609a83bdae17)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "b32b3bd2-e2ac-448f-8e9d-3efea7831205",
    "data-name": "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "862837c3-f02c-4075-80e2-0d6e8e0a806a",
    "data-name": "path2998",
    d: "M595.1,506.22,571,489.29V400.13l24.29,7.44v59.95l-23.59,21,57.57-30.29-16-7.22-10.8-23.42L655.83,444V470Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#f4bd27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b78c3c1b-fd7c-4cdd-831f-943502e589c6",
    "data-name": "flowRoot3000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a1aaba5c-87d1-494e-b4db-e2424d267e74",
    "data-name": "path3009",
    d: "M695,478.43h-.18V485H687.6v-67l7.25,2.16v27.56H695q5.35-9,15.66-9,8.71,0,13.64,6.08t4.93,16.3q0,11.37-5.53,18.2T708.6,486A14.9,14.9,0,0,1,695,478.43Zm-.18-18.27v6.32A13.47,13.47,0,0,0,698.5,476a13,13,0,0,0,19.59-1.13q3.74-5,3.74-14,0-7.56-3.49-11.85a11.56,11.56,0,0,0-9.46-4.29,12.85,12.85,0,0,0-10.17,4.4,16.16,16.16,0,0,0-3.85,11Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#f4bd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2b46ba4-c904-4cc9-9109-f48bfd422836",
    "data-name": "path3011",
    d: "M742.46,429.34a4.59,4.59,0,0,1-3.32-1.33,4.48,4.48,0,0,1-1.37-3.36,4.64,4.64,0,0,1,4.69-4.73,4.68,4.68,0,0,1,3.38,1.35,4.72,4.72,0,0,1,0,6.7A4.64,4.64,0,0,1,742.46,429.34ZM746,485h-7.25V439.69H746Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#f4bd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e38629ea-396c-4cd4-a9ef-8c6412e7dcde",
    "data-name": "path3013",
    d: "M795.64,485h-7.25V459.15q0-14.42-10.53-14.42a11.42,11.42,0,0,0-9,4.09,15.16,15.16,0,0,0-3.56,10.33V485h-7.25V439.69h7.25v7.52h.18q5.13-8.58,14.86-8.58,7.43,0,11.37,4.8t3.94,13.86Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#f4bd27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7a43e19-a069-4d09-9407-0ca788ab83ee",
    "data-name": "path3015",
    d: "M847,481.35q0,24.94-23.88,24.94a32.07,32.07,0,0,1-14.68-3.18l2-6.5c4.44,2.19,8.52,3.41,12.59,3.41,10.78,0,16.74-5.85,16.74-17.7v-5h-.18Q834.35,486,824,486a17,17,0,0,1-13.6-6c-3.43-4-5.3-9.5-5.3-16.28,0-7.7,2-13.74,5.7-18.28s8.87-6.94,15.3-6.94c6.1,0,10.52,2.21,13.47,7.1h.18v-5.91H847ZM839.7,464.5v-6.68A13.06,13.06,0,0,0,827,444.73c-10.5,0-14.25,9.55-14.33,18.57,0,8.61,4.38,16.29,13.31,16.29S839.61,472.53,839.7,464.5Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#f4bd27"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "79792e90-82bf-4238-a4af-cd0948953fb1",
    "data-name": "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d238b1b1-b934-4f75-9b9b-f38f789b39c3",
    "data-name": "path38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M862.05,324.38c-5.31,0-10.84,3.88-10.84,3.88v-2.49c0-.55-.22-.77-.76-.77h-6.78a.78.78,0,0,0-.87.77v53.15c0,.55.22.88.77.88h6.89a.78.78,0,0,0,.76-.88v-45.5a14.73,14.73,0,0,1,7.08-2c3.7,0,6.61,1.84,6.61,5.6v41.92a.81.81,0,0,0,.87.88h6.77a.78.78,0,0,0,.76-.88V334.61C873.31,327.94,869.21,324.38,862.05,324.38Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#13dbe9af-638b-435e-9f44-8918d669c0cb)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "917579d8-8aae-424a-b443-a10d1fe52665",
    "data-name": "path40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.76,297.72H908a.78.78,0,0,0-.87.77V325.3a20,20,0,0,0-6.88-1.53c-11,0-18.56,10.53-18.56,30.77,0,17.34,7.35,26.65,16.94,26.65,4,0,7.38-2.32,9.82-4.49l1.48,2.51a.93.93,0,0,0,1,.58h3.9a.78.78,0,0,0,.77-.88V298.48c0-.55-.22-.77-.76-.77Zm-24.13,55c0-11.15,3.26-22.2,9.92-22.2a10.28,10.28,0,0,1,6.56,2.44v39.3a12.85,12.85,0,0,1-6,1.75C893.83,374,890.63,365.44,890.63,352.75Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#6e785759-1792-4e56-ab13-97f1c71d675c)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "8c6db44b-25c2-4c11-b17a-480760c306ff",
    "data-name": "path42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940.72,323.88c-11.28,0-16.85,14.77-16.85,30.85,0,16.83,7.94,26.26,18.16,26.26a25.82,25.82,0,0,0,11.89-3.4.82.82,0,0,0,.42-1l-.86-3.56a.76.76,0,0,0-.87-.65,36.23,36.23,0,0,1-7.54,1.08c-8.36,0-12.19-7.44-12.19-17.31v-2.4a63.71,63.71,0,0,0,6.65.58h15.77v-4.56c0-16.84-5.89-25.85-14.57-25.85Zm-.54,23.57c-2.5,0-7,.62-7,.62s.06-1.81.28-3.55c1-9.23,3.18-13.9,7-13.9,3.3,0,5.57,4.78,6.11,13.14.11,1.74.11,3.69.11,3.69h-6.43Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#1b9d0fbd-4a18-480c-8952-bc1dca6d3c24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c697e1ca-ddd9-45ac-9ec9-31a6877d9bb6",
    "data-name": "path44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.92,330.78c-2.51-4.94-7-7.1-12.08-7.1a33.86,33.86,0,0,0-11.83,2.8c-.67.3-1.09.57-1.09,1.09a2.21,2.21,0,0,0,.33,1l2.31,4.94a1,1,0,0,0,.93.69,1.71,1.71,0,0,0,.92-.36c3.34-2.14,5.79-3.31,7.72-3.31,2.56,0,4.3,1.7,5.37,4.26a25.6,25.6,0,0,1,1.39,9.48c0,.49,0,1.12,0,1.12a17.27,17.27,0,0,0-7.57-2c-9.79,0-15.07,9.31-15.07,19.26,0,10.73,6.17,18.59,13.59,18.59,4.13,0,7.87-2.43,10.37-5.48,0,0,1.33,3.18,1.51,3.56a.77.77,0,0,0,.86.52h4a.78.78,0,0,0,.76-.88V348.08c0-7.58-.38-13.36-2.38-17.3Zm-6,40.39a9.43,9.43,0,0,1-6.36,2.86,5.94,5.94,0,0,1-5-2.76c-1.58-2.18-2.31-5.54-2.31-9.25,0-5.88,2.17-11.91,6.77-11.91a11.15,11.15,0,0,1,6.91,2.44v18.63Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#08a32409-e9e2-41c9-b320-daf7c916d8a5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ff4fa252-6ee1-4f25-bde5-0a4b374039a4",
    "data-name": "path46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.08,325h-6a1.17,1.17,0,0,0-1.19.81c-.38,1-2.94,7.73-4,10.52-.75,2-2.76,7.69-2.76,7.69h-.23s-1.48-4.15-2.28-6.21c-.64-1.68-4-10.54-4.44-11.64-.23-.59-.48-1.17-1.35-1.17H962.2a1,1,0,0,0-.9,1.29c.24.5,10.77,24.51,10.77,24.51s-11.31,26.89-11.64,27.49a1,1,0,0,0,.89,1.5h5.79c1,0,1.37-.52,1.67-1.35.83-2.33,2.07-5.58,3.83-10.6,1.16-3.33,3-9.16,3-9.16h.2s2,5.95,2.76,7.89c1.89,4.92,4.32,11.34,4.57,12s.64,1.2,1.32,1.2H991c.65,0,1-.74.65-1.39-.73-1.54-7-16.72-11.3-26.69,0,0,11.25-24.84,11.47-25.45s.15-1.26-.77-1.26Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#b2338fc2-5e48-4cc0-83aa-3fe60e8d838c)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "79f0924f-12b4-4187-96c3-4ef7db672aef",
    "data-name": "path48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.1,289.72h-7.62a1.09,1.09,0,0,0-1.19.81c-.1.48-11.42,35-12.25,37.92-.58,2-2.49,9.24-2.94,11l-3.94-10.76c-1-3-10.13-28.61-10.4-29.64-.15-.56-.41-1.26-1.39-1.26h-7.44A1,1,0,0,0,760,299c.19.4,13.62,36.16,19,49.82v30c0,.55.22.88.77.88h7a.78.78,0,0,0,.76-.88v-29.8c4.52-12.64,21-57.62,21.23-58.13s.16-1.26-.77-1.26Z",
    transform: "translate(-164.05 -180.55)",
    fill: "url(#250804e8-9fcb-4348-8b6b-ec6692d86991)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "d1c7a373-120e-4263-88e0-20e0671c3dc9",
    "data-name": "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "8b7152ff-683f-476b-a613-e78fe121e9f8",
    "data-name": "path38",
    d: "M863,325.14c-4.94,0-10.1,3.61-10.1,3.61v-2.32c0-.51-.2-.71-.71-.71h-6.31a.73.73,0,0,0-.81.71v49.49c0,.51.2.82.71.82h6.41a.73.73,0,0,0,.71-.82V333.56a13.71,13.71,0,0,1,6.59-1.89c3.44,0,6.16,1.71,6.16,5.21v39a.75.75,0,0,0,.81.82h6.31a.72.72,0,0,0,.71-.82V334.67C873.49,328.45,869.68,325.14,863,325.14Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c6648a63-5afe-4686-8775-d8042d885f82",
    "data-name": "path40",
    d: "M912.08,300.32h-6.31a.73.73,0,0,0-.81.71v25a18.64,18.64,0,0,0-6.41-1.42c-10.25,0-17.28,9.8-17.28,28.65,0,16.15,6.84,24.81,15.77,24.81,3.76,0,6.87-2.16,9.15-4.18l1.38,2.34a.86.86,0,0,0,.89.54h3.63a.73.73,0,0,0,.71-.82V301c0-.51-.2-.71-.71-.71Zm-22.47,51.24c0-10.39,3-20.67,9.24-20.67a9.57,9.57,0,0,1,6.11,2.27v36.59a12,12,0,0,1-5.62,1.63C892.6,371.38,889.62,363.37,889.62,351.56Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8ebde601-e4a8-4ba4-a58e-6ed2eed807f8",
    "data-name": "path42",
    d: "M936.25,324.68c-10.51,0-15.69,13.75-15.69,28.72,0,15.67,7.4,24.45,16.9,24.45a24,24,0,0,0,11.07-3.16.77.77,0,0,0,.39-1l-.8-3.31a.7.7,0,0,0-.81-.61,33.73,33.73,0,0,1-7,1c-7.78,0-11.35-6.92-11.35-16.12v-2.23a59.31,59.31,0,0,0,6.19.54h14.68v-4.25c0-15.68-5.49-24.07-13.57-24.07Zm-.51,21.95c-2.32,0-6.55.57-6.55.57s.06-1.69.26-3.31c.91-8.6,3-12.94,6.5-12.94,3.08,0,5.18,4.45,5.69,12.24.1,1.62.1,3.44.1,3.44h-6Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4bb227d-30ce-41b9-90ac-a7d472bb05c4",
    "data-name": "path44",
    d: "M833.1,331.11c-2.33-4.6-6.49-6.61-11.25-6.61a31.52,31.52,0,0,0-11,2.6c-.62.28-1,.53-1,1a2.06,2.06,0,0,0,.31.92l2.15,4.6a.91.91,0,0,0,.87.64,1.59,1.59,0,0,0,.86-.33c3.11-2,5.39-3.08,7.19-3.08,2.39,0,4,1.58,5,4a23.84,23.84,0,0,1,1.29,8.83c0,.45,0,1,0,1a16.08,16.08,0,0,0-7-1.9c-9.12,0-14,8.67-14,17.93,0,10,5.75,17.31,12.65,17.31,3.85,0,7.33-2.26,9.66-5.11,0,0,1.24,3,1.4,3.32a.72.72,0,0,0,.8.49h3.69a.73.73,0,0,0,.71-.82V347.21c0-7.05-.36-12.43-2.22-16.1Zm-5.62,37.61a8.78,8.78,0,0,1-5.92,2.66,5.53,5.53,0,0,1-4.66-2.57c-1.47-2-2.15-5.15-2.15-8.61,0-5.47,2-11.09,6.3-11.09a10.38,10.38,0,0,1,6.43,2.27v17.34Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0e65a99c-9adc-4d1d-86b7-022bb92efd88",
    "data-name": "path46",
    d: "M983.14,325.71h-5.62a1.09,1.09,0,0,0-1.11.76c-.36.94-2.73,7.2-3.71,9.79-.69,1.85-2.57,7.16-2.57,7.16h-.22s-1.38-3.86-2.12-5.79c-.6-1.56-3.73-9.82-4.13-10.84-.21-.55-.45-1.09-1.25-1.09h-6.16a.91.91,0,0,0-.84,1.2c.22.46,10,22.82,10,22.82s-10.53,25-10.84,25.6a1,1,0,0,0,.83,1.39h5.4c.92,0,1.28-.48,1.56-1.26.78-2.17,1.93-5.2,3.57-9.87,1.08-3.1,2.8-8.53,2.8-8.53h.19s1.88,5.54,2.57,7.35c1.76,4.58,4,10.56,4.26,11.19s.6,1.12,1.23,1.12h6.12c.61,0,.89-.69.6-1.29-.68-1.44-6.49-15.56-10.53-24.85,0,0,10.47-23.12,10.67-23.7s.14-1.18-.72-1.18Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c96c6d06-e931-4679-98ae-89e17d7c35f9",
    "data-name": "path48",
    d: "M812.78,292.87h-7.09a1,1,0,0,0-1.11.76c-.09.45-10.64,32.63-11.4,35.31-.54,1.9-2.32,8.6-2.74,10.21l-3.67-10c-.89-2.76-9.43-26.64-9.68-27.59-.14-.52-.38-1.18-1.3-1.18h-6.92a.91.91,0,0,0-.84,1.2c.17.37,12.68,33.67,17.73,46.39v28c0,.51.2.82.71.82H793a.73.73,0,0,0,.71-.82V348.17c4.21-11.77,19.6-53.65,19.76-54.12s.14-1.18-.72-1.18Z",
    transform: "translate(-164.05 -180.55)",
    fill: "#e52620"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.803a5f438fa214dd0793d47e64548a4f.svg";
export { ForwardRef as ReactComponent };